import { AreaModel } from "types/models/AreaModel";
import { CityModel } from "types/models/CityModel";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
import { StateModel } from "types/models/StatesModel";
export const GET_Customer = "GET_Customer";
export const SET_Customer_DATA = "SET_Customer_DATA";
export const CREATE_Customer = "CREATE_Customer";
export const RESET_Customer_DATA = "RESET_Customer_DATA";
export const DELETE_Customer = "DELETE_Customer";
export const GET_CITIES="GET_CITIES";
export const SET_CITY_DATA="SET_CITY_DATA";
export const SET_STATES_DATA = "SET_STATES_DATA";
export const SET_AREAS_BY_CITY="SET_AREAS_BY_CITY";
export const UPDATE_Customer = "UPDATE_Customer";

export interface GetCustomerAction {
  type: typeof GET_Customer;
  payload: { customer: CustomerMasterData[]; count: number };
}
export interface GetCityAction {
  type: typeof GET_CITIES
  payload: { rows: CityModel[]; count: number };
}
export interface SetStatesAction {
  type: typeof SET_STATES_DATA;
  payload: { rows: StateModel[]; count: number }; 
}
export interface DeleteCustomer{
  type: typeof DELETE_Customer;
  payload: any;
}
export interface SetCityAction {
  type: typeof SET_CITY_DATA;
  payload: CityModel;
}


export interface SetAreasByCityAction {
  type: typeof SET_AREAS_BY_CITY
  payload: { rows: AreaModel[]; count: number };
}
export interface SetCustomerDetailAction {
  type: typeof SET_Customer_DATA;
  payload: CustomerMasterData;
}
export interface createCustomer{
  type: typeof CREATE_Customer;
    payload: any; 
}
export interface updateCustomer{
  type: typeof UPDATE_Customer;
    payload: any; 
}
export interface ResetCustomer{
  type: typeof RESET_Customer_DATA;
}

export type CustomerMasterActionTypes =
  | GetCustomerAction
  | SetCustomerDetailAction
  | createCustomer
  | updateCustomer
  | ResetCustomer
  | GetCityAction
  | SetAreasByCityAction
  | SetCityAction
  | DeleteCustomer
  | SetStatesAction;  
